import { endAuth0Session, getAppPublicRootUrl } from "../core";
import { useAuth } from "./useAuth";

/**
 * Ways out of a failed sign-in. `tryAgain` reloads the app's root, dropping
 * Auth0's `?error=&state=` so sign-in starts fresh. `signOut` ends the Auth0
 * session even though sign-in never completed, so a user stuck behind it can
 * switch account (useSignOut offers nothing to a signed-out user); undefined
 * when auth is disabled.
 */
export function useSignInRecovery(): { tryAgain: () => void; signOut: (() => void) | undefined } {
  const { isEnabled, logout } = useAuth();
  return {
    tryAgain: () => window.location.assign(getAppPublicRootUrl()),
    signOut: isEnabled ? () => endAuth0Session(logout) : undefined,
  };
}
